module.exports = __webpack_public_path__ + "static/media/tw.3e3f17e3.svg";